/**
 * @copyright 2019 @ DigiNet
 * @author kimlong
 * @create 2019/07/15 15:37
 * @update 2019/07/15 15:37
 * @file src/actions/async/check-export-report-async.js
 */

import Api from '../../services/api.js';
export default async (param)=> {
    return new Promise((resolve, reject) => {
        Api.put('/w17/check-export-report', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    return resolve(0);
                } else {
                    return resolve(result.data);
                }
            });
    });
};
